"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request5"));
var _fileImage = _interopRequireDefault(require("@/components/fileImage.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _vuex = require("vuex");
var _user = require("@/api/user");
var _formatMixin = require("@/utils/formatMixin");
var _auth = require("@/utils/auth");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    FileImage: _fileImage.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    }
  }),
  data: function data() {
    return {
      document: {},
      listLoading: false,
      orderList: {
        count: 0
      },
      moneyList: {
        count: 0
      },
      // 充值余额流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      accoutform: {
        sumcharge: 0,
        //账户余额
        chargeMoney: 0,
        // 充值总值    
        riskMoney: 0,
        // 蚁盾消费总值
        reportMoney: 0,
        // 报表消费总值
        paRyiskBehaviorMoney: 0,
        // 探针C消费总值
        unifyMoney: 0,
        // 全景雷达消费总值
        scorePanoMoney: 0,
        // 全景档案消费总值
        courtDetailProMoney: 0,
        // 风控策略消费总值
        ZhengXinMoney: 0,
        //征信调用消费总值
        ApplyLoanCMoney: 0,
        //3c租赁总值
        DefaultFengkongMoney: 0,
        GzMoney: 0
      },
      // 余额提现form

      dialogVisibleshop: false,
      // 控制修改商家信息form
      // 保存从服务器获取的修改收费form数据,开关数据也在里面，用于展示
      dialogVisiblerisk: false,
      chargeform: {
        report_money: 0,
        bear_money: 0,
        // 
        key: '',
        // 
        key_secret: ''
      },
      moneyform: {
        bear_money: ''
      },
      // 以下为商家收费配置3个开关的值
      value1: true,
      value2: true,
      value3: true,
      // 收集修改收费form数据，提交给后端

      // 商家基础信息
      shopInfo: {},
      // 修改商家基础信息form
      shopform: {
        company_name: '',
        address: '',
        scc: '',
        product_name: '',
        email: '',
        status: '',
        aa_id: '',
        bb_id: '',
        cc_id: '',
        mobile: ''
      },
      isRequesting: false,
      // 控制按钮是否禁用的标志位
      lastExecutedTime: 0,
      // 上次执行的时间
      currentName: '',
      //风控名称
      currentType: '',
      // 风控类型
      currentPrice: '',
      // 风控价格
      // 调用风控信息弹窗form
      userform: {
        name: '',
        card_code: '',
        mobile: ''
      }
    };
  },
  created: function created() {
    // this.pk = this.$route.query.id
    // 获取商家数据
    this.getList1();
    this.getMoneyInfo();
    // 获取充值余额流水

    // 获取商家收费配置数据
    this.getCharge();
  },
  methods: {
    //获取商家费用流水信息数据
    getMoneyInfo: function getMoneyInfo() {
      var _this = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/shopConfig/getMoneyInfo/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop
        }
      }).then(function (res) {
        console.log(res.data.data);
        _this.accoutform.sumcharge = res.data.data.sumMoney; //账户余额
        _this.accoutform.chargeMoney = res.data.data.sumMoney1,
        // 蚁盾消费总值
        _this.accoutform.riskMoney = res.data.data.sumMoney2 + res.data.data.sumMoney3;
        _this.accoutform.reportMoney = res.data.data.sumMoney4 + res.data.data.sumMoney5 - res.data.data.sumMoney6,
        // 报表消费总值
        _this.accoutform.paRyiskBehaviorMoney = res.data.data.sumMoney7 - res.data.data.sumMoney8,
        // 探针C消费总值
        _this.accoutform.unifyMoney = res.data.data.sumMoney9 - res.data.data.sumMoney10,
        // 全景雷达消费总值
        _this.accoutform.scorePanoMoneyy = res.data.data.sumMoney11 - res.data.data.sumMoney12,
        // 全景档案消费总值
        _this.accoutform.courtDetailProMoney = res.data.data.sumMoney13 - res.data.data.sumMoney14,
        // 风控策略消费总值
        _this.accoutform.ZhengXinMoney = res.data.data.sumMoney15,
        // 征信消费总值
        _this.accoutform.ApplyLoanCMoney = res.data.data.sumMoney16, _this.accoutform.DefaultFengkongMoney = res.data.data.sumMoney17, _this.accoutform.GzMoney = res.data.data.sumMoney18,
        // ZhengXinMoney
        _this.listLoading = false;
        console.log(_this.accoutform);
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 获取商家信息数据——新接口
    getList1: function getList1() {
      var _this2 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/shopConfig/getInfoAll/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop
        }
      }).then(function (res) {
        _this2.shopInfo = res.data;
        _this2.shopform.company_name = res.data.company_name;
        _this2.shopform.address = res.data.address;
        _this2.shopform.scc = res.data.scc;
        _this2.shopform.product_name = res.data.product_name;
        _this2.shopform.email = res.data.email;
        _this2.shopform.status = res.data.status;
        _this2.shopform.mobile = res.data.mobile;
        _this2.listLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    handleFilter: function handleFilter() {
      this.getList();
    },
    // 页头--返回上级页面——done
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getCharge: function getCharge() {
      var _this3 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getConfig/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          _this3.chargeform = response.data;
          _this3.moneyform.bear_money = response.data.bear_money;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    showfengkong: function showfengkong(name, type, price) {
      var _this4 = this;
      //   const token=getToken()
      // 获取风控名称、风控类型、风控价格
      this.currentName = name;
      this.currentType = type;
      this.currentPrice = price;
      if (!price) {
        this.$message({
          message: "".concat(name, "\u6682\u672A\u5F00\u542F\uFF0C\u8BF7\u5F00\u542F\u540E\u518D\u8C03\u7528"),
          type: 'warning'
        });
        return;
      }
      if (type == 'report_money' || type == 'bear_money') {
        this.$confirm("\u786E\u5B9A\u8981\u67E5\u8BE2".concat(name, "\u5417\uFF1F\u67E5\u8BE2\u5C06\u6D88\u8017<span style=\"color: red; font-weight: bold;\">").concat(price, "\u8C46/\u6B21</span>"), '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(function () {
          if (type == 'report_money') {
            // 此处跳转报告管理模块
            _this4.$router.push({
              path: '/Report/ReportGet'
            });
          } else {
            _this4.$router.push({
              path: '/OrderHk/riskHk'
            });
          }
        }).catch(function () {
          _this4.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      } else {
        // this.dialogVisiblerisk = true
        this.$router.push({
          path: '/OrderHk/fengkongUser'
        });
      }
    },
    get_token: function get_token() {
      var _this5 = this;
      (0, _request2.default)({
        url: "/get_token",
        method: 'post',
        data: {
          key: this.chargeform.key,
          secret: this.chargeform.key_secret
        }
      }).then(function (res) {
        console.log(res);
        (0, _auth.setTokenInfo)('apiToken', res.token, 3);
        _this5.setfengkong(res.token);
      }).catch(function (err) {
        console.log(err);
      });
    },
    setfengkong: function setfengkong(token) {
      var _this6 = this;
      var url = "/risk/pay_risk_behavior";
      if (this.currentType == 'unify_money') {
        url = "/risk/unify";
      }
      if (this.currentType == 'score_pano_money') {
        url = "/risk/score_pano";
      }
      if (this.currentType == 'court_detail_pro_money') {
        url = "/risk/court_detail_pro";
      }
      if (this.currentType == 'apply_loan_c_money') {
        url = "/risk/apply_loan_c";
      }
      (0, _request2.default)({
        url: url,
        method: 'post',
        headers: {
          "Token": token
        },
        data: {
          real_name: this.userform.name,
          card_no: this.userform.card_code,
          mobile: this.userform.mobile
        }
      }).then(function (res) {
        if (res.code == 0 || res.code == "0" || res.code == 200) {
          if (res.msg && res.msg !== '成功') {
            _this6.$message({
              message: res.msg,
              type: 'warning',
              duration: 5000
            });
          }
          _this6.$router.push({
            name: 'ReportTable',
            query: {
              id: res.record_id,
              type: _this6.currentType
            }
          });
        } else {
          _this6.$message({
            message: res.msg || '调用失败',
            type: 'error',
            duration: 6000
          });
        }
      }).catch(function (err) {
        var msg = err && err.message ? err.message : '调用失败';
        if (msg && msg !== '请求出错') {
          _this6.$message({
            message: msg,
            type: 'error',
            duration: 6000
          });
        }
      });
    } // 确认查询提示
    // confirmfn() {
    //   if (this.userform.name == '' || this.userform.card_code == '' || this.userform.mobile == '') {
    //     this.$message({
    //       message: '请填写完整信息',
    //       type: 'warning'
    //     })
    //     return
    //   }
    // //   验证身份证号
    //   const chineseIDCardNumberRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
    //   if (!chineseIDCardNumberRegex.test(this.userform.card_code)) {
    //     this.$message({
    //       message: '身份证号格式错误',
    //       type: 'warning'
    //     });
    //     return;
    //   }
    //   // 验证手机号
    //   const chinesePhoneNumberRegex = /^1[3456789]\d{9}$/;
    //   if (!chinesePhoneNumberRegex.test(this.userform.mobile)) {
    //     this.$message({
    //       message: '手机号格式错误',
    //       type: 'warning'
    //     })
    //     return
    //   }
    //   this.dialogVisiblerisk = false
    //   // 弹窗提示将消耗多少豆，确定后再查询
    //   this.$confirm(`确定要查询${this.currentName}吗？查询将消耗<span style="color: red; font-weight: bold;">${this.currentPrice}豆/次</span>`, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //       dangerouslyUseHTMLString: true
    //   }).then(() => {
    //     // 此处调用风控查询接口,调用成功清空数据
    //         const apiToken=getTokenInfo('apiToken')
    //       if(apiToken){
    //           console.log(apiToken)
    //           this.setfengkong(apiToken)
    //       }else{
    //           this.get_token()
    //       }
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消操作'
    //     });
    //     // 清空数据
    //     this.userform = {
    //       name: '',
    //       card_code: '',
    //       mobile: ''
    //     }
    //     this.currentName = ''
    //     this.currentType = ''
    //     this.currentPrice = ''
    //   });
    // }
  }
};